import client from "@irati/utils/services/apollo"
import getTenantFromPath from "@irati/identity/helpers/getTenantFromPath"
import region from "@irati/region/services/region"
import {getGlobalTenant} from "@irati/region/services/globalTenant"

import AuthStorage from "../auth/storage"
import UnAuthed from "../../types/UnAuth"
import resumeUnauthedQuery from "../../services/queries/resumeUnauthed"
import AuthServiceAbstract from "../auth/base"

class UnAuthedStream extends AuthServiceAbstract<UnAuthed> {
  isValid(auth?: UnAuthed) {
    return !!(auth && auth.unauthedBusiness && auth.branding && auth.userTenant)
  }

  async init() {
    const data = await this.storage.get()

    if (!this.isValid(data)) {
      return this.start(data)
    } else {
      this.data = data
    }
  }

  protected query() {
    const variables = {subdomain: getTenantFromPath()}

    return async() => {
      if (!region.get() && getTenantFromPath()) {
        try {
          const regional = await getGlobalTenant(getTenantFromPath())
          region.set(regional.region)
        } catch (e) {
          /* no-op */
        }
      }

      return client.watchQuery<UnAuthed>({query: resumeUnauthedQuery, variables})
    }
  }
}

export default new UnAuthedStream({storage: new AuthStorage("unauth")})
